import React, {useState} from 'react';
import {connect} from 'react-redux';
import {editRemoveCellularItem} from '../../saleBlockAsyncThunk';
import {reportDWH} from '../../saleJetBlockSlice';
import PopUp from '../../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Image from 'app/Components/Shared/Image/image';
const PriceItemListCellular = (props) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState(null);

  function editOrRemoveCellularItem(action, phoneNumber){
    if (props.closeShoppingCartPopUp) {
      props.closeShoppingCartPopUp();
    }
    if(action == 'Disconnect'){
      if(props.page == 'summaryPage'){
        props.reportDWH({ actionType: 'Summary Page', status: 'Ongoing', messageText: 'Removal Line in Summery Clicked' });
      }
      else{
        props.reportDWH({ actionType: 'Cart', status: 'Ongoing', messageText: 'Removal Line in Cart Clicked' });
      }
    }
    else{
      if(props.page == 'summaryPage'){
        props.reportDWH({ actionType: 'Summary Page', status: 'Ongoing', messageText: 'Edit Line in Summery Clicked' });
      }
      else{
        props.reportDWH({ actionType: 'Cart', status: 'Ongoing', messageText: 'edit Line in Cart Clicked' });
      }
    }
    props.editRemoveCellularItem({phoneNumber: phoneNumber ?? selectedPhoneNumber , action: action});
  }

  function deleteCellularPopUp(phoneNumber) {
    setSelectedPhoneNumber(phoneNumber);
    setShowPopUp(true);
  }

  function closeDeleteCellularPopUp() {
    setShowPopUp(false);
  }

  return (
    <div className='price-item-list-wrapper-cellular'>
      <div className='section-wrapper'>
        <div className='section-title'> חיובים חודשיים </div>
        <div className='section-details'>
          <div className='cellular-price-item-wrapper'>
          {props.summaryDetails?.cellularShoppingCart?.orderPrices?.map((item, index) => {
            return (
              <>
              <div key={index} className='cellular-price-item'>
                <div className='title-wrapper cellular-item-row'>
                  <div className='phone-number'>
                    קו {index + 1} | {item.phoneNumberFormat}
                  </div>
                  <div className='btns-wrapper-line-actions'>
                    <div>
                      {props.summaryDetails?.cellularShoppingCart?.orderPrices?.length > 1 &&
                      <button
                        className='remove btn'
                        onClick={() => {
                          deleteCellularPopUp(item.phoneNumber);
                        }}>
                        הסרה
                      </button>
                      }
                    </div>
                    <div>
                      <button
                        className='edit btn'
                        onClick={() => {
                          editOrRemoveCellularItem('Change' ,item.phoneNumber);
                        }}>
                        עריכה
                      </button>
                    </div>
                  </div>
                </div>
                <div className='package-title cellular-item-row'>{item.package.title}</div>
                {item.offerItemList?.map((offer, index) => {
                  return (
                    <div className='cellular-item-row price-text-wrapper' key={index}>
                      <div className='text'>{offer.priceText}</div>
                      <span className='price'>
                        {displayPrice(offer.price)}
                        <span className='nis'>₪</span>{' '}
                      </span>
                    </div>
                  );
                })}
                {item.addonsPrices?.map((addon, index) => {
                  return addon.priceItemList?.map((priceItem, index) => {
                    return (
                      <div className='cellular-item-row price-text-wrapper' key={index}>
                        <div className='text'>
                          {addon.billDescription} {priceItem.priceText}
                        </div>
                        <span className='price'>
                          {displayPrice(priceItem.price)}
                          <span className='nis'>₪</span>{' '}
                        </span>
                      </div>
                    );
                  });
                })}
              </div>
              <div className='separator'/>
              </>
            );
          })}
        </div>


          <div className='summary'>
            {props.summaryDetails?.cellularShoppingCart?.fullPrice?.map((item, index) => {
              return (
                <div className='summary-row' key={index}>
                  <div className='title-wrapper'>{item.priceText}</div>
                  <div className='price-wrapper'>
                    <span className='price'>
                      {displayPrice(item.price)}
                      <span className='nis'>₪</span>
                      <span className='price-text'>לחודש</span>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {props.summaryDetails?.oneTimePriceList?.length > 0 && (
        <div className='section-wrapper one-price-wrapper'>
          <div className='section-title'> חיוביים חד פעמיים </div>
          <div className='section-details'>

          <div className='cellular-price-item-wrapper'>
            {props.summaryDetails?.oneTimePriceList?.filter((item) => !item.isDeliveryPrice).map((item, index) => {
              return (<>
                <div key={index} className='cellular-price-item'>
                  <div className='title-wrapper cellular-item-row one-price-title'>
                    <div className='phone-number'>
                      קו {index + 1} | {item.phoneNumberFormat}
                    </div>
                  </div>
                  {item.oneTimePriceObjList?.map((onePriceItem, priceIndex) => (
                    <div key={priceIndex} className='cellular-item-row price-text-wrapper'>
                      <div className='text-one-price'>{onePriceItem.priceText}</div>
                      <span className='price'>
                        {displayPrice(onePriceItem.price)}
                        <span className='nis'>₪</span>{' '}
                      </span>
                    </div>
                  ))}
                </div>
                <div className='separator'/>
                </>
              )
            })}
            {props.summaryDetails?.oneTimePriceList?.filter((item) => item.isDeliveryPrice).map((item, index) => {
              return (
                <>
                  <div key={`delivery-${index}`} className='cellular-price-item'>
                    <div className='cellular-item-row price-text-wrapper'>
                      <div className='text-one-price'>{item.priceText}</div>
                      <span className='price'>
                        {displayPrice(item.price)}
                        <span className='nis'>₪</span>{' '}
                      </span>
                    </div>
                  </div>
                  <div className='separator'/>
                </>
              );
            })}
          </div>

            <div className='summary'>
              <div className='summary-row'>
                <div className='title-wrapper'>סה"כ חיוב חד פעמי</div>
                <div className='price-wrapper'>
                  <span className='price'>
                    {displayPrice(props.summaryDetails.totalPriceOneTime)}
                    <span className='nis'>₪</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <PopUp
        showPopUp={showPopUp}
        onClose={() => {
          closeDeleteCellularPopUp(false);
        }}
        className='delete-cellular-popup'>
        <div className='delete-cellular-popup-wrapper'>
          <Image src={require('./images/hand.svg')} alt='' />
          <h1>בטוח שאתם רוצים לוותר על קו מספר {selectedPhoneNumber}</h1>
          <p>אם תרצו לרכוש קו נוסף, תצטרכו להתחיל מחדש</p>
          <div className='buttons-wrapper'>
            <div className='btn-right'>
              <BtnWhiteBlackBorderBigSize
                text={'חזרה לתהליך'}
                onclick={() => {
                  closeDeleteCellularPopUp(false);
                }}
              />
            </div>
            <div className='btn-left'>
              <BtnSubmit
                isBusiness={false}
                text={'הסירו את הקו'}
                onclick={() => {
                  editOrRemoveCellularItem('Disconnect' , null);
                }}
                formid={'package-for-upgrade-popUp'}
                isDisplayArrows={false}
              />
            </div>
          </div>
        </div>
      </PopUp>
    </div>
  );

  function displayPrice(price) {
    if (typeof price === 'number') {
      return parseFloat(price.toFixed(2));
    } else {
      return parseFloat(parseFloat(price).toFixed(2));
    }
  }
};

const mapStateToProps = (state) => {
  return {
    page: state.saleJetBlock.page,

  };
};

const mapDispatchToProps = {
  editRemoveCellularItem,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceItemListCellular);
